import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  influencerDetails: null,
  loading: false,
  enrichmentLoading: false,
  error: null,
};

export const ultimateDetailsSlice = createSlice({
  name: 'ultimateDetailsSlice',
  initialState,
  reducers: {
    setInfluencerDetails: (state, action) => {
      state.influencerDetails = action.payload;
      state.loading = false;
      state.enrichmentLoading = false;
      state.error = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setEnrichmentLoading: (state, action) => {
      state.enrichmentLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.enrichmentLoading = false;
    },
    resetDetails: (state) => {
      state.influencerDetails = null;
      state.loading = false;
      state.enrichmentLoading = false;
      state.error = null;
    },
  },
});

export const { setInfluencerDetails, setLoading, setEnrichmentLoading, setError, resetDetails } = ultimateDetailsSlice.actions;
export default ultimateDetailsSlice.reducer;